import toast from 'react-hot-toast';
import eventService from './eventService';
import { clearListCache } from '../hooks/useListCache';
import { umamiTrack } from './analytics';

/**
 * „Merken" ohne Login: Die Event-ID wird hier geparkt und nach der nächsten erfolgreichen
 * Anmeldung automatisch als Favorit eingelöst — egal ob die über das Login-Formular oder den
 * Bestätigungslink der Registrierung (anderer Tab, daher localStorage statt Router-State) läuft.
 */

const KEY = 'pendingFavorite';

// Nach 24h (Gültigkeit des Bestätigungslinks) verfallen lassen, damit ein längst vergessener
// Klick nicht Wochen später beim nächsten Login ein Event favorisiert.
const TTL_MS = 24 * 60 * 60 * 1000;

// Von redeemPendingFavorite gemerkt, damit ConfirmEmail das Redirect-Ziel abfragen kann.
let lastRedeemedId: number | null = null;

export const rememberPendingFavorite = (eventId: number): void => {
  try {
    localStorage.setItem(KEY, JSON.stringify({ id: eventId, ts: Date.now() }));
  } catch {
    // Storage blockiert (z. B. Privatmodus) — dann eben ohne Auto-Merken.
  }
};

/**
 * Löst einen geparkten Favoriten ein (einmalig, Eintrag wird immer entfernt).
 * Gibt die Event-ID zurück, wenn das Favorisieren geklappt hat, sonst null.
 */
export const redeemPendingFavorite = async (): Promise<number | null> => {
  let raw: string | null = null;
  try {
    raw = localStorage.getItem(KEY);
    if (raw) localStorage.removeItem(KEY);
  } catch {
    return null;
  }
  if (!raw) return null;

  let id: number;
  try {
    const parsed = JSON.parse(raw);
    id = parsed.id;
    if (!Number.isInteger(id) || id <= 0 || Date.now() - parsed.ts > TTL_MS) return null;
  } catch {
    return null;
  }

  try {
    await eventService.addFavorite(id);
  } catch {
    // Event inzwischen gelöscht o. Ä. — still scheitern, der Login selbst war ja erfolgreich.
    return null;
  }
  clearListCache('landing');
  clearListCache('favorites');
  umamiTrack('event-favorit', { id, aktion: 'nach-login' });
  toast.success('Event gemerkt ✓');
  lastRedeemedId = id;
  return id;
};

/** Holt die zuletzt eingelöste Event-ID ab (einmalig), z. B. fürs Redirect-Ziel nach Bestätigung. */
export const consumeRedeemedFavorite = (): number | null => {
  const id = lastRedeemedId;
  lastRedeemedId = null;
  return id;
};
